export const walletApiHandler = {
  getAllWallets: {
    method: "GET",
    path: () => `wallet`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'search'?: string | number}
  },
  getWalletById: {
    method: "GET",
    path: (payload: { id: string | number }) => `wallet/${payload.id}`
  },
  getWalletByUserId: {
    method: "GET",
    path: (payload: { userId: string | number }) => `wallet/user/${payload.userId}`
  },
  getWalletLogs: {
    method: "GET",
    path: (payload: { userId: string | number }) => `wallet/logs/${payload.userId}`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'type'?: string | number, 'activity'?: string | number}
  },
  createWalletLog: {
    method: "POST",
    path: (payload: { userId: string | number }) => `wallet/logs/${payload.userId}`,
    params: {} as {'type'?: string | number, 'skip'?: string | number, 'take'?: string | number}
  },
  updateBalance: {
    method: "POST",
    path: () => `wallet/balance`
  },
  transferToBank: {
    method: "POST",
    path: () => `wallet/transfer-to-bank`
  },
  redeemPoints: {
    method: "POST",
    path: () => `wallet/redeem`
  },
  createWallet: {
    method: "POST",
    path: () => `wallet`
  }
};